// extracted by mini-css-extract-plugin
module.exports = {"tabsBar":"ProductTabSwitcher_tabsBar__3e4kv","tab":"ProductTabSwitcher_tab__Q16kL"};